import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import ProductCard from '../components/ProductCard';
import { allProducts } from '../data/mockData';
import { Search, SlidersHorizontal } from 'lucide-react';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

const Animals = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('name');
    const [products, setProducts] = useState([]);
    const [categoriesData, setCategoriesData] = useState([]);
    const [animalsData, setAnimalsData] = useState([]);
    const [foodData, setFoodData] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        fetchProducts();
        fetchCategoriesData();
        fetchAnimalData();
        fetchFoodData();
    }, []);

    const goToProductPage = (type, id) => {
        navigate(`/products?${type}=${id}`);
    };

    const fetchAnimalData = async () => {
        const querySnapshot = await getDocs(collection(db, "animalCategories"));

        const list = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        setAnimalsData(list)
    };

    const fetchFoodData = async () => {
        const querySnapshot = await getDocs(collection(db, "foodCategories"));

        const list = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        setFoodData(list)
    };



    const fetchProducts = async () => {
        const querySnapshot = await getDocs(collection(db, "products"));

        const list = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        setProducts(list)
    };

    const fetchCategoriesData = async () => {
        const querySnapshot = await getDocs(collection(db, "categories"));

        const list = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        setCategoriesData(list)
        console.log(list)
    };



    // const filteredProducts = allProducts
    //   .filter(product => {
    //     const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
    //     const matchesCategory = selectedCategory === 'all' || product.category === selectedCategory;
    //     return matchesSearch && matchesCategory;
    //   })
    //   .sort((a, b) => {
    //     if (sortBy === 'price-low') return a.price - b.price;
    //     if (sortBy === 'price-high') return b.price - a.price;
    //     if (sortBy === 'rating') return b.rating - a.rating;
    //     return a.name.localeCompare(b.name);
    //   });

    return (
        <div>
            <section className="py-5 bg-light">
                <Container>
                    <div className="d-flex justify-content-center align-items-center mb-4">
                        <div>
                            <h2 className="fw-bold mb-2 w-100 text-center">Shop By Breed</h2>
                        </div>
                    </div>

                    <Row className="g-4 d-flex justify-content-center">
                        {animalsData.map((category) => (
                            <Card className="border-0 shadow-sm h-100 shopByBreedCard p-0 mx-2">
                                <div className="position-relative overflow-hidden" style={{ height: '300px' }}>
                                    <img
                                        src={category.image}
                                        alt={category.name}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.3s ease',
                                            borderRadius: '15px'
                                        }}
                                    />
                                    <div
                                        className="position-absolute bottom-0 start-0 w-100 p-3 shopByBreedCardBottom"
                                        style={{
                                            background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                                        }}
                                    >
                                        <h4 className="text-white fw-bold mb-1 text-center">{category.name}</h4>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </Row>

                </Container>
            </section>


            <section className="py-5">
                <Container>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h2 className="fw-bold mb-2">Food Essentials</h2>
                        </div>
                    </div>

                    <Row className="g-4">
                        {categoriesData.map((category) => (
                            <Col key={category.id} sm={6} md={3} lg={2}>
                                <Card className="h-100 shadow-md border-0 product-card">
                                    <div className="position-relative overflow-hidden" style={{ height: '150px' }}>
                                        <Card.Img
                                            variant="top"
                                            src={category.image}
                                            alt={category.name}
                                            style={{
                                                height: '100%',
                                                objectFit: 'cover',
                                                transition: 'transform 0.3s ease'
                                            }}
                                            className="product-image"
                                        />
                                    </div>
                                    <Card.Body className="d-flex flex-column py-0">
                                        <Card.Title className="fs-6 my-1 categoryCustomCardText text-center">{category.name}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            <section className="py-5 bg-light">
                <Container>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h2 className="fw-bold mb-2">Shop By Brands</h2>
                            <p className="text-muted">Browse our wide selection of premium cat product brands</p>
                        </div>
                    </div>

                    <div className="g-4 horizontalScroll pb-3">

                        {animalsData.map((category) => (
                            <div className="scroll-item p-0 mx-2" key={category?.id}>
                                <Card className="border-0 shadow-sm category-card h-100" onClick={() => goToProductPage('animal', category?.id)}>
                                    <div className="position-relative overflow-hidden" >
                                        <img
                                            src={category.image}
                                            alt={category.name}
                                            style={{
                                                width: '170px',
                                                height: '170px',
                                                objectFit: 'cover',
                                                transition: 'transform 0.3s ease'
                                            }}
                                            className="category-image"
                                        />
                                        <div
                                            className="categoryNameText w-100 p-3"
                                            style={{
                                                background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)'
                                            }}
                                        >
                                            <h4 className="text-white fw-bold mb-1">{category.name}</h4>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        ))}
                    </div>

                </Container>
            </section>

            <section className="py-5">
                <Container>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h2 className="fw-bold mb-2">Toys & Accessories</h2>
                        </div>
                    </div>

                    <Row className="g-4">
                        {categoriesData.map((category) => (
                            <Col key={category.id} sm={6} md={3} lg={2}>
                                <Card className="h-100 shadow-md border-0 product-card">
                                    <div className="position-relative overflow-hidden" style={{ height: '150px' }}>
                                        <Card.Img
                                            variant="top"
                                            src={category.image}
                                            alt={category.name}
                                            style={{
                                                height: '100%',
                                                objectFit: 'cover',
                                                transition: 'transform 0.3s ease'
                                            }}
                                            className="product-image"
                                        />
                                    </div>
                                    <Card.Body className="d-flex flex-column py-0">
                                        <Card.Title className="fs-6 my-1 categoryCustomCardText text-center">{category.name}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>



        </div>
    );
};

export default Animals;